module.exports = global.config = {
  plans: [
    { mb: "100Mb", price: "150.000" },
    { mb: "100Mb", price: "150.000" },
  ],
  mision:
    "Nuestra misión es proporcionar conexiones de internet confiables y de alta velocidad que impulsen la conectividad digital y mejoren la vida de nuestros clientes. Nos comprometemos a ofrecer un servicio  excepcional, innovador y accesible, centrado en la satisfacción del cliente y en la mejora continua de nuestras infraestructuras     tecnológicas.",
};
